import {createSlice} from "@reduxjs/toolkit";

const sideNavSlice = createSlice({
    name: "sideNav",
    initialState: {
        showNav: false
    },
    reducers: {
        setShowNav: (state, action) => {
            state.showNav = !state.showNav;
        },

    }
});

export const {setShowNav} = sideNavSlice.actions;
export default sideNavSlice.reducer;